import React from 'react';
import { ExternalOffices, SpecialistUnit } from '../../../../models/Specialist';
import { capitalize } from '../../../../utils/formatters';
import { maskPhone, removeMask } from '../../../../utils/masks';

import { Container, UnitName, UnitPhone } from './styles';

type UnitContactsProps = {
  unit: SpecialistUnit | ExternalOffices;
  onClickOnContact: () => void;
};

export const UnitContacts: React.FC<UnitContactsProps> = ({ unit, onClickOnContact }) => {
  const checkStringItems = (list: string[]) => {
    return list.some(item => item.length > 0);
  };

  const getContactValue = (unit: SpecialistUnit | ExternalOffices) => {
    return unit.contacts.find(contact => {
      if (contact.contact_type.name === 'Contato para agendamento') {
        if (contact?.value?.landlines && contact.value.cell_phone_numbers && contact.value.others)
          return checkStringItems([
            ...contact.value.landlines,
            ...contact.value.cell_phone_numbers,
            ...contact.value.others
          ]);
      }
    });
  };

  const contacts = getContactValue(unit)?.value;

  return (
    <Container>
      {contacts && (
        <>
          <UnitName>{unit.name && capitalize(unit.name)}</UnitName>

          {contacts?.landlines &&
            contacts?.landlines.map((contact, index) => (
              <UnitPhone key={index} href={`tel:${removeMask(contact)}`} onClick={onClickOnContact}>
                {maskPhone(contact)}
              </UnitPhone>
            ))}

          {contacts?.cell_phone_numbers &&
            contacts?.cell_phone_numbers.map((contact, index) => (
              <UnitPhone key={index} href={`tel:${removeMask(contact)}`} onClick={onClickOnContact}>
                {maskPhone(contact)}
              </UnitPhone>
            ))}

          {contacts?.others &&
            contacts?.others.map((contact, index) => (
              <UnitPhone key={index} href={`tel:${removeMask(contact)}`} onClick={onClickOnContact}>
                {maskPhone(contact)}
              </UnitPhone>
            ))}
        </>
      )}
    </Container>
  );
};
